<template>
  <button
    type="button"
    class="vdr-btn ring-secondary-500/50 group fixed bottom-4 right-4 z-40 inline-flex items-center gap-2.5 rounded-full bg-brand-500 py-2.5 pl-3 pr-4 text-[10px] font-semibold uppercase tracking-[0.22em] text-white shadow-lg ring-1 transition hover:ring-secondary-500"
    :disabled="resetting"
    title="Reset the Virtus demo to its starting state"
    @click="reset"
  >
    <svg
      class="h-3.5 w-3.5 text-secondary-500 transition-transform duration-500 group-hover:-rotate-180"
      :class="resetting ? 'vdr-spin' : ''"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5" />
    </svg>
    {{ resetting ? 'Resetting…' : 'Reset demo' }}
  </button>
</template>

<script>
export default {
  name: 'VirtusDemoReset',

  data() {
    return { resetting: false };
  },

  methods: {
    reset() {
      if (this.resetting) return;
      // eslint-disable-next-line no-alert
      if (!window.confirm('Reset the Virtus demo (requests, messages and invoices) to its starting state?')) {
        return;
      }
      this.resetting = true;
      this.$store.dispatch('virtusDemo/reset');
      // Reload so every on-mount fetch and local component state starts clean.
      setTimeout(() => window.location.reload(), 250);
    },
  },
};
</script>

<style scoped>
.vdr-spin {
  animation: vdr-rotate 0.8s linear infinite;
}
@keyframes vdr-rotate {
  to { transform: rotate(-360deg); }
}
</style>
